import { Link } from 'react-router-dom';
import './ImmediateService.css';

export default function ImmediateService() {
  return (
    <section className="immediate" aria-labelledby="immediate-heading">
      <div className="immediate-inner">
        <div className="immediate-row">
          <div className="immediate-visual">
            <img
              src="/images/immediate-service.png"
              alt="SnapScrap collector ready to collect scrap metal from a property"
              loading="lazy"
            />
          </div>

          <div className="immediate-copy">
            <h2 id="immediate-heading">Post Your Scrap. We&apos;ll Do the Rest.</h2>
            <p>
              Got unwanted metal? Post your scrap in just a few taps. Add photos, choose your
              collection availability and get connected with a local collector.
            </p>
            <Link className="immediate-cta" to="/post-scrap">
              Post Scrap →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
